import { api } from '../../shared/api/client'

export const jobsAPI = {
  getActiveJobs: () => api.get('/jobs/active'),
  getAllJobs: (limit?: number) => api.get('/jobs', { params: { limit } }),
  getJob: (jobId: string) => api.get(`/jobs/${jobId}`),
  cancelJob: (jobId: string) => api.post(`/jobs/${jobId}/cancel`),
  finishStoppedJob: (jobId: string) => api.post(`/jobs/${jobId}/finish`),
}
